import * as _ from 'underscore';
import { SiteRoleOptionsResource } from '../resources/SiteRoleOptions';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { ISelectFilterDefinitionOption } from '../services/FilterPanelService';

export module SiteRoleFilterHelper {

  export let AnyRole = 'Any';

  export function siteRoleOptions(roles: string[], siteRoleOptionsResource: SiteRoleOptionsResource, userCountsByRole?: _.Dictionary<number>) {

    if (!userCountsByRole) {
      userCountsByRole = {};
    }

    const options: ISelectFilterDefinitionOption<string>[] = [
      {
        value: AnyRole,
        translate: 'siteRole_Any',
        count: userCountsByRole[AnyRole]
      }
    ];

    _.each(roles, (role: string) => {
      if ((role !== SiteRoles.SupportUser) || userCountsByRole[role] > 0) {
        options.push({
          value: role,
          translate: siteRoleOptionsResource.getSiteRoleLockey(role),
          count: userCountsByRole[role]
        });
      }
    });

    return options;
  }

}
